// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"275f380fc5c4a50d394f","691":"b1467645d67f227f8440","731":"fcac888b6c2808f57da3","843":"2034b603c06e004b1095"}[chunkId] + ".js";
};